module.exports = __webpack_public_path__ + "static/media/about-us-2.8c22f6bf.jpg";